import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import de from 'vuetify/es5/locale/de';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {    
    options: {
      customProperties: true,
      variations: true      
    },
    dark: false,
    themes: {

      light: {
        primary: '#ff0000',
        secondary: '#444444',
        accent: '#FF0000',
        error: '#FF0000',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FFC107',
        tertiary: '#ebebeb',
        footer: '#000',
        footerInvers: '#fff',
        appshell:"#fff"
      },
      dark: {
        primary: '#FF0000',
        secondary: '#444444',
        accent: '#FF0000',
        error: '#FF0000',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FFC107',
        tertiary: '#272727',
        footer: '#fff',
        footerInvers: '#000',
      },
    },
  },
  lang: {
    locales: { de },
    current: 'de',
  },
});
